import { useLocation, useParams } from 'react-router-dom';

import { useAppLayoutContext } from '@/components/app-layout/context';

import BuilderForm from '../components/BuilderForm';
import BulkPublishRunner from '../components/builder/bulk-publish/Runner';
import { BULK_PUBLISH_PARAM } from '../components/builder/bulk-publish/protocol';
import { PostProvider, usePostStore } from '../store';

function PostBuilderForm() {
  const { id } = useParams()
  const { setMenuCollapsed } = useAppLayoutContext()
  setMenuCollapsed(true)

  const { collection: { useLoad } } = usePostStore()

  useLoad(id)

  return <BuilderForm />
}

export default function PostBuilderFormLayout() {
  const { search } = useLocation()
  const bulkPublish = new URLSearchParams(search).get(BULK_PUBLISH_PARAM)

  if (bulkPublish) {
    return <BulkPublishRunner />
  }

  return <PostProvider>
    <PostBuilderForm />
  </PostProvider>
}
